import httpUtils from '../../utils/HttpUtils'
import Tool from "../../utils/Tools";
import EnvUtils from '@/utils/EnvUtils'

class ConfigService {

  //获取微信支付的配置
  async getPayConfig (url) {
    console.log('获取微信支付的配置');
    var result = null;
    try {
      if (Tool.verfyBrowserType() || EnvUtils.inLight()) {
        result = await httpUtils.post('/config/wechat/getSignature',{url});
        wx.config({
          appId: result.data.appId,
          timestamp: result.data.timestamp,
          nonceStr: result.data.nonceStr,
          signature: result.data.signature,
          jsApiList: [
            // 所有要调用的 API 都要加到这个列表中
            'checkJsApi',
            'openLocation',
            'getLocation',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'uploadImage',
            'chooseImage'
          ]
        });
        wx.ready(function (){
          console.log('wxsdk配置成功');
        })
        wx.error(function (res) {
          console.log('wxsdk配置失败', JSON.stringify(res));
        });
      }
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new ConfigService()
